import { useMutation } from '@tanstack/react-query';

import { fetchJson } from '../fetch';
import { checkEmailAddressInUseSchema } from './schemas';

type Payload = {
  emailAddress: string;
};

export const useCheckEmailAddressInUse = () => {
  return useMutation({
    mutationFn: async (body: Payload) => {
      const { inUse } = await fetchJson('/registration/email-address-in-use', {
        method: 'POST',
        schema: checkEmailAddressInUseSchema,
        body,
      });

      return inUse;
    },
  });
};
